import React from "react";
import { Modal, Box } from "@mui/material";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import CrossIcon from "../assests/croosicon.png";
import UserImg from "../assests/sampleuser.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import configuration from "../../config/Config";

const CommentModal = ({ open, onClose, data,loadMore,hasMore }) => {
  // console.log("op",loadMore,hasMore);
  
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
     
      <Box
       id='scrollableDiv'
        sx={{
          borderRadius: "32px",
          backgroundColor: "#FFF",
          width: "100%",
          // maxWidth: "500px",/
          
          maxWidth:"450px",
          height: "380px",
          overflow: "scroll",
          // overflowY:'auto',
          boxSizing: "border-box",
          padding: "20px",
          
          marginX: {
            xs: "30px",
            sm: "30px",
            md: "30px",
            lg: "35px",
          },
          "@media (min-width: 1600px)": {
            marginX: "32px",
          },
          display: "flex",
          flexDirection: "column",
          "&::-webkit-scrollbar": {
            display: "none", // Hides scrollbar in WebKit browsers
          },
          msOverflowStyle: "none", // Hides scrollbar in IE and Edge
          scrollbarWidth: "none", // Hides scrollbar in Firefox
        }}
       
      >


          <InfiniteScroll
                dataLength={data.length}
                next={loadMore}
                hasMore={hasMore}
                loader={<h4>Loading...</h4>}
                endMessage={
                  <p style={{ textAlign: "center" }}>
                    <b>You have seen it all</b>
                  </p>
                }
                scrollableTarget="scrollableDiv"
                key={data.length}
              >
        {/* Content  here */}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "15px",
          }}
        >
          <div
            style={{
              fontWeight: "700",
              fontFamily: "Heebo",
              color: "#362B24",
              fontSize: "20px",
            }}
          >
            Comments
          </div>
          <div onClick={onClose}>
            <img
              src={CrossIcon}
              alt="Close"
              style={{ width: "20px", height: "20px", cursor: "pointer" }}
            />
          </div>
        </div>

        {data?.length > 0 ? (
          data.map((item) => (
            <>
              <div
                style={{
                  paddingLeft: "15px",
                  paddingRight: "15px",
                  display: "flex",
                  gap: "10px",
                }}
              >
              <img
                src={
                  item?.userId?.picture
                    ? `${configuration.cdnFront}/${item?.userId?.picture}`
                    : UserImg
                }
                alt="user-img"
                style={{ width: "50px", height: "45px",borderRadius:'50%' }}
              />

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  width:"100%"
                }}
              >
                <div style={{ fontWeight: "500",wordBreak:'break-all', }}>
                  {item?.userId?.fullname || "N/A"}
                </div>
                <div style={{ opacity: "0.6",wordBreak:'break-all',}}>
                 {item?.comment||"N/A"}
                </div>

                <div style={{ opacity: "0.4", fontSize: "12px" }}>
                  <WatchLaterIcon sx={{ fontSize: "17px" }} />
                  {item?.created_at
                    ? `${new Date(item?.created_at).toLocaleDateString(
                        "en-GB",
                        {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        }
                      )}, ${new Date(item?.created_at).toLocaleTimeString(
                        "en-GB",
                        {
                          hour: "2-digit",
                          minute: "2-digit",
                        }
                      )}`
                    : "N/A"}
                </div>
                <div
                  style={{
                    border: "1px solid grey",
                    marginBottom: "10px",
                    width: "100%",
                    opacity: "0.6",
                  }}
                ></div>
              </div>
              
              </div>
            </>
          ))
        ) : (
          <div style={{ textAlign: "center" }}>No Data Found</div>
        )}
        </InfiniteScroll>
        {/* </div> */}
      </Box>
      {/* </InfiniteScroll> */}
    </Modal>
  );
};

export default CommentModal;
